import { SunIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Sun = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <SunIcon size={Sizes[size]} {...rest} />;
};

Sun.displayName = 'Sun';
